import { Component, Input } from '@angular/core';
import { AgRendererComponent, ICellRendererAngularComp } from 'ag-grid-angular';
import { QualityScoreCellRendererParams } from '../quality-score.model';
import { ModuleManager } from 'src/shared/models/module-manager';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-quality-score-metric-cell-renderer',
  templateUrl: './quality-score-metric-cell-renderer.component.html',
  styleUrls: ['./quality-score-metric-cell-renderer.component.scss']
})
export class QualityScoreMetricCellRendererComponent implements ICellRendererAngularComp {
    @Input() moduleManager: ModuleManager;

    params: QualityScoreCellRendererParams;
    value: string;
    color: string;
    tooltipValues: any;

    constructor(private cvLocalizationService: CVLocalizationService,) {}

    refresh(params: QualityScoreCellRendererParams): boolean {
        this.params = params;
        this.value = params.value.MetricDisplayValue;
        this.tooltipValues = params.data;
        this.color = this.params.data.ColorData.Color;
        return true;
    }

    agInit(params: QualityScoreCellRendererParams): void {
        this.params = params;
        this.value = params.value.MetricDisplayValue;
        this.tooltipValues = params.data;
        this.color = this.params.data.ColorData.Color;
    }
        
    public getLocaleText(key: string, defaultValue: string) {
        return this.cvLocalizationService.getCachedText("Quality_Score_Module", key, defaultValue);
    }

    public formatNumber(value: string | number): string | number {        
        let parsedValue = typeof value === 'string' ? parseFloat(value): value;
        if (Number.isNaN(parsedValue)) {
          return value;
        }

        if (Number.isInteger(parsedValue)) {
            return parsedValue;
        } else {
            const factor = Math.pow(10, 2);
            return  Math.round(parsedValue * factor) / factor;
        }
    }
}
